

import { useMemo } from "react";
import { TypedTable } from "@/components/ui/table/TypedTable";
import { CommonFeatures } from "@/hooks/useTanstackTable";
import { createColumnHelper, tableFeatures, type RowSelectionState } from "@tanstack/react-table";
import type { Familia } from "./GestionFamiliasOcultas";
import { getSelectionCell } from "@/components/ui/table/datatable";


interface TablaFamiliasProps {
	readonly familias?: Familia[];
	readonly ocultas: RowSelectionState;
	readonly setOcultas: Setter<RowSelectionState>;
	readonly loading: boolean;
}
export function TablaFamilias(props: TablaFamiliasProps) {
	const { columns, features } = useMemo(() => Columns(), []);

	return (
		<TypedTable
			className="dataTable display"
			data={props.familias ?? []}
			features={features}
			columns={columns}

			getRowId={row => row.id}
			selection={props.ocultas}
			setSelection={props.setOcultas}

			pagination
			globalSearch

			noResultsMessage="No se encontraron pedidos"
			errorMessage="Error al cargar los pedidos"
			isLoading={props.loading}
			isError={false}
		/>
	);
}



function Columns() {
	const columnHelper = createColumnHelper<typeof features, Familia>();
	const features = tableFeatures(CommonFeatures);


	const columns = columnHelper.columns([
		columnHelper.display({
			id: "checkbox",
			meta: { style: { width: "2cm" } },
			cell: (info) => getSelectionCell(info.row),
		}),
		columnHelper.accessor("id", { header: "ID", meta: { className: "text-center" } }),
		columnHelper.accessor("descripcion", { header: "Descripcion" }),
	]);
	return { columns, features };
}